import Vue from "vue";
import VueRouter from "vue-router";
import Home from "@/pages/Home.vue";
import SignUp from "@/pages/SignUp.vue";
import Login from "@/pages/Login.vue";
import Users from '@/pages/Users/Users.vue';
import UsersForm from '@/pages/Users/UsersForm.vue';
import UserRolesForm from '@/pages/Users/UserRolesForm.vue';
import UserPermissionsForm from '@/pages/Users/UserPermissionsForm.vue';
import Overview from '@/pages/Overview/Overview.vue';
import Registration from '@/pages/Registration.vue';
import ForgottenPassword from '@/pages/ForgottenPassword.vue';
import ChangePassword from '@/pages/ChangePassword.vue';
import NewPUSelection from '@/pages/NewPU/NewPUSelection.vue';
import NewPUAsset from '@/pages/NewPU/NewPUAsset.vue';
import PageNotFound from '@/pages/PageNotFound.vue';
import store from '@/store'

Vue.use(VueRouter);

const routes = [
    {
      path: "/",
      name: "/home",
      component: Home,
      children: [
        {
          path: 'overview',
          name: 'Overview',
          component: Overview
        },
        {
          path: 'registration',
          name: 'Registration',
          component: Registration
        },
        {
          path: 'users',
          name: 'Users',
          component: Users
        },
        {
          path: 'usersform',
          name: 'UsersForm',
          component: UsersForm
        },
        {
          path: 'userrolesform',
          name: 'UserRolesForm',
          component: UserRolesForm
        },
        {
          path: 'userpermissionsform',
          name: 'UserPermisssionsForm',
          component: UserPermissionsForm
        },
        {
          path: "/changepassword",
          name: "ChangePassword",
          component: ChangePassword
        },
        {
          path: "/newpuselection",
          name: "NewPUSelection",
          component: NewPUSelection
        },
        {
          path: "/newpuasset",
          name: "NewPUAsset",
          component: NewPUAsset
        }
      ]
    },
    {
      path: "/sign-up",
      name: "sign-up",
      component: SignUp
    },
    {
      path: "/login",
      name: "login",
      component: Login
    },
    {
      path: "/forgottenPassword",
      name: "ForgottenPassword",
      component: ForgottenPassword
    },
    { 
      path: '*', 
      name: 'PageNotFound',
      component: PageNotFound 
    }
  ]

  const router = new VueRouter({
    routes
  })

  router.beforeEach((to, from, next) => {
    // Redirect to login page if not logged in and trying to access a restricted page
    const publicPages = ['/login']
    
    const authRequired = !publicPages.includes(to.path)
    const token = `${store.state.token}`
    let exp = undefined
    let loggedIn = false
  
    if (token !== undefined && token !== null && token !== '') {
      exp = parseJwt(token).exp
      loggedIn = (Date.now() / 1000) < exp
    }
  
    if (authRequired && !loggedIn) {
      return next('/login')
    }
  
    if (to.path == '/')
    {
      return next('overview')
    }
  
    next()
  })
  
  function parseJwt (token) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
  
    return JSON.parse(jsonPayload);
  }
  
  export default router